import React from 'react';
import ProcessMessage from '../../common/process-message/ProcessMessage';

const ProcessSuccess = ({ text }: { text: string }) => {
  return <ProcessMessage text={text} messageType='success' />;
};

export default ProcessSuccess;
